module.exports = __webpack_public_path__ + "static/fakenews2-0de629bebbef5500c3dba197336afa91.png";